import { autoinject, bindable, bindingMode } from 'aurelia-framework';
import { TaskActionService } from '../../TaskActionService';
import { UiActionButton } from '../../UiActionButton';
import { PageMessageService } from '../../../../services/page-message-service';
import { BusyService } from '../../../../services/busy-service';
import { DialogService } from 'aurelia-dialog';
import { WebApiService } from '../../../../services/web-api-service';
import { SecurityService } from '../../../../services/security-service';
import { CmpTaskDto } from '../../../../data/typegen/dtos/cmp-task-dto';
import { TaskState } from '../../../../data/enums/taskState';
import { validateTrigger, ValidationController, ValidationControllerFactory } from 'aurelia-validation';
import { DefaultValidationRenderer } from '../../../../resources/renderers/default-validation-renderer';
import { FulfillmentWidget, IFulfillmentWidget } from '../../new-user-request/new-user-request-fulfillment';
import { AppMessageService } from '../../../../services/app-message-service';
import { DoUiActionDto } from '../../../../data/typegen/dtos/do-ui-action-dto';
import { CmpTaskBaseDto } from '../../../../data/typegen/dtos/cmp-task-base-dto';
import { DoUiActionClientHandlerResult } from '../../../../data/dtos/do-ui-action-client-handler-result';
import { PromptDialog } from '../../../../resources/dialogs/prompt-dialog';
import { ComposeEmailDialog } from '../../../dialogs/compose-email-dialog/compose-email-dialog';
import { Globals } from '../../../../models/globals';
import { NewOnboardingRequestDialog } from './new-onboarding-request-dialog/new-onboarding-request-dialog';

@autoinject()
export class CarrierReevaluationRequestFulfillment extends FulfillmentWidget implements IFulfillmentWidget {

    public entityTypes: { id: string; description: string; }[] = new Globals().getEntityTypes();

    public invalidFields: any = {
    };


    public get isTrucksCarrier(): boolean {
        return this.task && (this.task.variables.EntityType == "TRUCKS" || this.task.variables.EntityType == 'TRANSLOADER/TRUCKS');
    }

    async validate(controller: ValidationController, obj) {
        let isFormValid = true;

        if (!this.isComponentReadonly) {
            for (var field in this.task.variables) {
                if (this.task.variables.hasOwnProperty(field)) {
                    var isFieldValid = this.isFieldValid(field);

                    if (!isFieldValid) {
                        this.invalidFields[field] = "has-error";
                        isFormValid = false;
                    } else {
                        this.invalidFields[field] = "";
                    }
                }
            }
        }
        return isFormValid;
        //controller.addError("that's a no no", this, "task.variables.DotNumber");
    }

    private isFieldValid(field: string) {
        switch (field) {
            case "CarrierNumber":
            case "DateNeeded":
            case "Divisions":
            case "DescribeNeeds":
                return this.isNotEmpty(field);
            default:
                return true;
        }
    }

    private isEmail(field: string) {
        const vars = this.task.variables;
        const val = vars[field];
        return val && val.toString().match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/);
    }

    private isNotEmpty(field) {
        const vars = this.task.variables;
        return !!(vars[field]);
    }

    public isComponentReadonly = false;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) readonly: boolean;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) task: CmpTaskDto;
    taskChanged() {
        this.initUi();
    }

    public myDivisions = [];

    loadCarrierMills() {
        this.busyService.on();
        return this.api.get("Divisions", "GetDivisions")
            .then((result) => {
                this.myDivisions = JSON.parse(result.response);
                this.busyService.off();
            });
    }
    controller: ValidationController = null;

    private sendToInsuranceReview: UiActionButton;
    private makeDormant: UiActionButton;
    private createNewOnboardingRequest: UiActionButton
    private denyNewOnboardingRequest: UiActionButton

    constructor(
        private controllerFactory: ValidationControllerFactory,
        private taskActionService: TaskActionService,
        private busyService: BusyService,
        private securityService: SecurityService,
        private appMsg: AppMessageService,
        private msg: PageMessageService,
        private dialogService: DialogService,
        private api: WebApiService,
        element: Element
    ) {
        super(element);
        this.controller = controllerFactory.createForCurrentScope();
        this.controller.validateTrigger = validateTrigger.change;
        this.controller.addRenderer(new DefaultValidationRenderer());

        // add UI actions based on the task key
        this.createNewOnboardingRequest = this.taskActionService.addUiAction({
            key: "create_new_onboarding_request",
            name: "Create New Onboarding Request",
            performValidation: true
        });

        // add UI actions based on the task key
        this.denyNewOnboardingRequest = this.taskActionService.addUiAction({
            key: "deny_new_onboarding_request",
            name: "Deny New Onboarding Request",
            performValidation: true
        });
        this.sendToInsuranceReview = this.taskActionService.addUiAction({
            key: "send_to_insurance_review",
            name: "Send to Insurance Review",
            performValidation: false
        });

        // add UI actions based on the task key
        this.makeDormant = this.taskActionService.addUiAction({
            key: "make_dormant",
            name: "Make Dormant",
            performValidation: false
        });

    }

    showCloseAction: boolean = false;

    public async showEmailDialog(email: string) {
        var result = await this.dialogService.open(
            {
                viewModel: ComposeEmailDialog,
                model: {
                    recipients: email,
                    targetRowId: this.task.taskId,
                    targetTable: this.task.taskClass.toString().toLowerCase()
                }
            });

    }

    public async initUi() {

        var carrierId = this.task.variables.CarrierId;
        var result = carrierId && await this.api.get("Carriers", "GetCarrierById", { carrierId: carrierId });
        const carrier = result && JSON.parse(result.response);


        var isEditor = this.securityService.hasRole("Edit");
        this.isComponentReadonly = this.readonly || !this.task.active || !isEditor

        const activeAssignedToMeInProgress = this.task.active == true
            && this.task.assignedTo.value == this.securityService.user.id
            && this.task.state.value == TaskState.InProgress;

        this.showCloseAction = false;
        
        //only show UI actions when task is assigned and active
        if (this.task.variables.IsReevaluationRequest) {
            this.createNewOnboardingRequest.visible = activeAssignedToMeInProgress && !this.isComponentReadonly;
            this.denyNewOnboardingRequest.visible = activeAssignedToMeInProgress && !this.isComponentReadonly;
        } else if (this.task.variables.IsDormancyReviewRequest) {
            this.sendToInsuranceReview.visible = activeAssignedToMeInProgress && !this.isComponentReadonly;
            this.makeDormant.visible = activeAssignedToMeInProgress && !this.isComponentReadonly;
        }
    }

    public async doAction(action: DoUiActionDto<CmpTaskBaseDto>): Promise<DoUiActionClientHandlerResult> {
        debugger;
        const onboardingRequestParams = {
            carrierName: this.task.variables.DbaName || this.task.variables.LegalName,
            startStep: undefined,
            sendLink: false
        };

        if (action.uiActionVerb.indexOf("sysverb") == 0) {
            var result = { submit: true, reload: true, performValidation: false };
            return result;
        }
        else if (action.uiActionVerb == this.createNewOnboardingRequest.key) {
            return await this.dialogService.open(
                {
                    viewModel: NewOnboardingRequestDialog,
                    model: onboardingRequestParams
                })
                .whenClosed((result) => {
                    if (!result.wasCancelled && result.output) {
                        action.payload = result.output;
                        return DoUiActionClientHandlerResult.default;
                    } else {
                        return DoUiActionClientHandlerResult.stop;
                    }
                });
        } else if (action.uiActionVerb == this.denyNewOnboardingRequest.key) {
            const question = "Please provide the reason why this re-evaluation request did NOT result in a new onboarding request.";
            return await this.dialogService.open(
                {
                    viewModel: PromptDialog,
                    model: question
                })
                .whenClosed((result) => {
                    if (result.output) {
                        action.payload = result.output;
                        return DoUiActionClientHandlerResult.default;
                    } else {
                        return DoUiActionClientHandlerResult.stop;
                    }
                });
        } else if (action.uiActionVerb == this.sendToInsuranceReview.key) {
            onboardingRequestParams.startStep = "initial_insurance_review";

            action.payload = onboardingRequestParams;
            return DoUiActionClientHandlerResult.default;
        } else {
            return Promise.resolve(DoUiActionClientHandlerResult.default);
        };
    }

    public async afterActionSubmit(uiAction: string, error?: any): Promise<boolean> {
        if (uiAction == this.createNewOnboardingRequest.key && !error) {
            this.appMsg.addSuccessMessage("New onboarding request has been created.");
        }
        // return true to reload the data
        return true;
    }

    async attached() {
        await this.securityService.init();
        await this.loadCarrierMills();
        await this.initUi();
        await this.fireOnreadyEvent();
    }
}